export default {
  promo: {
    metrics: {
      description_1: 'Önerilerin etkinliği',
      description_2: 'Mimari hız',
      description_3: 'Görselleştirme derinliği'
    }
  }
}
